import { AxiosError } from "axios";
import {ErrorResponse} from "../common/api/Models/ErrorResponse";

export function translateError<T>(error: AxiosError<ErrorResponse | (T & { messages: string[]; }) | (T & { messages: string[]; }[]) | string> | undefined) {
	if (error?.response?.status === 401 || error?.response?.status === 403) {
		return "It looks like you don't have permissions to perform this action. Please seek your manager regarding permissions.";
	}

	const res = error?.response?.data;
	
	if (typeof res === 'string') {
		return res;
	}

	if (Array.isArray(res)) {
		let messages = "";
		res.forEach((r) => {
			if (r.messages != null) {
				messages += r.messages.join(" ");
			}
		});

		return messages;
	}

	if (res && "message" in res && res.message) {
		return res.message;
	}

	if (res && "messages" in res && res.messages) {
		return res.messages.join(" ");
	}

	return "An unexpected error occurred.";
}